module.exports = __webpack_public_path__ + "img/5-5.02e84030.svg";